export default __webpack_public_path__ + "static/media/blockchain.7a3f315e.jpg";